import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef
} from 'react';
import NumberBox from 'devextreme-react/number-box';
import TextBox from 'devextreme-react/text-box';
import { Switch } from 'devextreme-react/switch';
import FileUploader from 'devextreme-react/file-uploader';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import DateBox from 'devextreme-react/date-box';
import { LoadIndicator } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import style from './settingsstock.module.scss';
import PopupMVP from '../../PopupMVP';

const SettingsStock = ({
  plantId,
  stockReducer: {
    storageTime,
    file
  },
  setSettingsPlantStorageTime,
  sendFileStockSettings,
  settingsReducer: { settings, holderSettings, loading },
  tabsReducer: { tabSelect },
  getSettingsPlant,
  getHolderSettingsPlant,
  setSettingsPlant,
  shippingType,
  setSettingsTNPlant,
  setUserManual,
  modalMessageOpen,
  modalErrorOpen,
  userReducer,
  fetchStock
}) => {
  const [valueStorageTime, setValueStorageTime] = useState(storageTime.data);
  const [data, setData] = useState({});
  const formFile = useRef(null);
  const fileUp = useRef(null);
  const formManualFile = useRef(null);
  const fileManualUp = useRef(null);
  const [valueStorageCost, setValueStorageCost] = useState(holderSettings.storageCost);
  const [valueOverStorageCost, setValueOverStorageCost] = useState(holderSettings.overStorageCost);
  // eslint-disable-next-line max-len
  const [valueWaterDeliveryPrice, setValueWaterDeliveryPrice] = useState(holderSettings.waterDeliveryPrice);
  const [valueHolderReportDay, setValueHolderReportDay] = useState(holderSettings.holderReportDay);
  const [visibleModalSettingsTN, setVisibleModalSettingsTN] = useState(false);
  const [visibleFieldsSettingsTN, setVisibleFieldsSettingsTN] = useState(settings.useTtnCreate);
  // eslint-disable-next-line max-len
  const [visiblePriorityExport, setVisiblePriorityExport] = useState(settings.usePriorityExportEmail);
  const [priorityShippingDays, setPriorityShippingDays] = useState({
    priority1ShippingDays: settings.priority1ShippingDays,
    priority2ShippingDays: settings.priority2ShippingDays
  });

  useEffect(() => {
    if (tabSelect === 5) {
      getSettingsPlant({ plant: plantId });
    }
  }, [getSettingsPlant, plantId, tabSelect]);

  /** Получение параметров для holder_report */
  useEffect(() => {
    if (tabSelect === 5) {
      getHolderSettingsPlant({ plant: plantId });
    }
  }, [getHolderSettingsPlant, plantId, tabSelect]);

  useEffect(() => {
    setData({
      autoAcceptIncoming: settings.autoAcceptIncoming,
      autoConfirmIntegrProduction: settings.autoConfirmIntegrProduction,
      autoOrderSigning: settings.autoOrderSigning,
      autoSignIncoming: settings.autoSignIncoming,
      checkDifferentShipmentMode:settings.checkDifferentShipmentMode,
      clientId: settings.clientId,
      contractDate: settings.contractDate,
      contractDateTtn: settings.contractDateTtn,
      contractEndDate: settings.contractEndDate,
      contractNoLog: settings.contractNoLog,
      contractNoTtn: settings.contractNoTtn,
      contractNum: settings.contractNum,
      disableTtnNumberInput: settings.disableTtnNumberInput,
      docNote: settings.docNote,
      executorIdSap: settings.executorIdSap,
      flowModel: settings.flowModel,
      holderReportDay: holderSettings.holderReportDay,
      notUseShippingContainer: settings.notUseShippingContainer,
      isHub: settings.isHub,
      loader: settings.loader,
      loaderAddress: settings.loaderAddress,
      loaderDetails: settings.loaderDetails,
      priceType: holderSettings.priceType,
      printQcFromQmet: settings.printQcFromQmet,
      printQcFromStorage: settings.printQcFromStorage,
      stockType: settings.stockType,
      storageCost: String(holderSettings.storageCost),
      overStorageCost: String(holderSettings.overStorageCost),
      tmStructId: settings.tmStructId,
      ttnAttachmentRequired: settings.ttnAttachmentRequired,
      useAZH: settings.useAZH,
      useBlockingMH3: settings.useBlockingMH3,
      useBuyoutWithTtn: settings.useBuyoutWithTtn,
      useCheckSeparation: settings.useCheckSeparation,
      useClientArrivalDate: settings.useClientArrivalDate,
      useCheckShiptoAddress: settings.useCheckShiptoAddress,
      useCreditLimitCheck: settings.useCreditLimitCheck,
      useDZCheck: settings.useDZCheck,
      useFactWeight: settings.useFactWeight,
      useFIFO: settings.useFIFO,
      useM15Incoming: settings.useM15Incoming,
      useM15B: settings.useM15B,
      useM4: settings.useM4,
      useMC: settings.useMC,
      useMhOnExpeditor: settings.useMhOnExpeditor,
      usePartialConfirm: settings.usePartialConfirm,
      usePDZCheck: settings.usePDZCheck,
      usePlacingRollsInCarBody: settings.usePlacingRollsInCarBody,
      useProductionLg: settings.useProductionLg,
      useProhibitionShipping: settings.useProhibitionShipping,
      useQcGenerationShipment: settings.useQcGenerationShipment,
      useSetContractBuyout: settings.useSetContractBuyout,
      useShippingFromSAP: settings.useShippingFromSAP,
      useShippingVehicleOnly: settings.useShippingVehicleOnly,
      useStorageLevels: settings.useStorageLevels,
      useSZRebinding: settings.useSZRebinding,
      useSZWorking: settings.useSZWorking,
      useTtnCreate: settings.useTtnCreate,
      waterDeliveryPrice: String(holderSettings.waterDeliveryPrice),
      showSemiAttrb: settings.showSemiAttrb,
      usePriorityExportEmail: settings.usePriorityExportEmail,
      priority1ShippingDays: settings.priority1ShippingDays,
      priority2ShippingDays: settings.priority2ShippingDays,
      emailsCopyPriorityExport: settings.emailsCopyPriorityExport,
      useZdvlNewEmail: settings.useZdvlNewEmail,
      useZdvlSignEmail: settings.useZdvlSignEmail,
      emailsForZdvlNew: settings.emailsForZdvlNew,
      emailsCopyForZdvlNew: settings.emailsCopyForZdvlNew,
      emailsForZdvlSign: settings.emailsForZdvlSign,
      emailsCopyForZdvlSign: settings.emailsCopyForZdvlSign,
      overrideContract: settings.overrideContract,
      useShippingDocumentFromSap: settings.useShippingDocumentFromSap
    });
  }, [settings, holderSettings]);

  useEffect(() => {
    setValueStorageTime(storageTime.data);
    setValueStorageCost(Number(data.storageCost));
    setValueWaterDeliveryPrice(Number(data.waterDeliveryPrice));
    setValueHolderReportDay(Number(data.holderReportDay));
    setValueOverStorageCost(Number(data.overStorageCost));
    setPriorityShippingDays({
      priority1ShippingDays: Number(data.priority1ShippingDays),
      priority2ShippingDays: Number(data.priority2ShippingDays)
    });
  }, [storageTime.data, data]);

  const onValueChangedStorageTime = useCallback(({ value }) => {
    setValueStorageTime(value);
  }, []);

  const onValueChangedStorageCost = useCallback(({ value }) => {
    setValueStorageCost(value);
  }, []);

  const onValueChangedOverStorageCost = useCallback(({ value }) => {
    setValueOverStorageCost(value);
  }, []);

  const onValueChangedWaterDeliveryPrice = useCallback(({ value }) => {
    setValueWaterDeliveryPrice(value);
  }, []);

  const onValueChangedHolderReportDay = useCallback(({ value }) => {
    setValueHolderReportDay(value);
  }, []);

  const onValueChangedPriorityShippingDays = useCallback((value, number) => {
    console.log('value =', value, 'number =', number);
    setPriorityShippingDays({
      priority1ShippingDays: (number === 1) ? value : priorityShippingDays.priority1ShippingDays,
      priority2ShippingDays: (number === 2) ? value : priorityShippingDays.priority2ShippingDays
    });
  }, [priorityShippingDays.priority1ShippingDays, priorityShippingDays.priority2ShippingDays]);

  // const onClick = useCallback(() => {
  //   if (valueStorageTime && valueStorageTime !== '') {
  //     setSettingsPlantStorageTime({
  //       plant: plantId,
  //       storageTime: valueStorageTime
  //     });
  //   }
  // }, [
  //   plantId,
  //   setSettingsPlantStorageTime,
  //   valueStorageTime
  // ]);

  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    // eslint-disable-next-line no-underscore-dangle
    if (fileUp.current.instance && fileUp.current.instance._files[0]) {
      sendFileStockSettings({
        plantId,
        // eslint-disable-next-line no-underscore-dangle
        file: fileUp.current.instance._files[0].value
      });
      fileUp.current.instance.reset();
    }
  }, [fileUp, plantId, sendFileStockSettings]);

  const formOnManualSubmit = useCallback((e) => {
    e.preventDefault();
    // eslint-disable-next-line no-underscore-dangle
    if (fileManualUp.current.instance && fileManualUp.current.instance._files[0]) {
      setUserManual({
        shippingType,
        // eslint-disable-next-line no-underscore-dangle
        file: fileManualUp.current.instance._files[0].value
      });
      fileManualUp.current.instance.reset();
    }
  }, [fileManualUp, shippingType, setUserManual]);

  const renderNumber = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите срок хранения"
               value={Number(valueStorageTime)}
               onValueChanged={onValueChangedStorageTime}
               width={300}
               showClearButton
    />
  ), [onValueChangedStorageTime, valueStorageTime]);

  /**
   Boolean    autoAcceptIncoming;       //AUTO_ACCEPT_INCOMING          F
              Автоматическое создание мх-1 и м15
   Boolean    autoConfirmIntegrProduction; //AUTO_CONFIRM_INTEGR_PRODUCTION F
              Автоматически подтверждать ГП через интеграцию
   Boolean    autoSignIncoming;         //AUTO_SIGN_INCOMING            F       Автоматическая ПЭП
   String     docNote;                  //DOC_NOTE
              Примечание к документу
   String     executorIdSap;            //EXECUTOR_ID_SAP
              Исполнитель в ZDVL - заказе
   Boolean    flowModel;                //FLOW_MODEL                    ПМ (F)
              Признак поточной модели
   Boolean    useM15Incoming;           //USE_M15_INCOMING              F
              Создавать М-15 при приемке
   Boolean    useM15B;                  //USE_M15B                      F
              Создавать М-15B при выкупе
   Boolean    useM4;                    //USE_M4                        F
              Использование акта М-4
   Boolean    useFIFO;                  //USE_FIFO                      F
              Использование принципа FIFO
   Boolean    useAZH;                   //USE_AZH                       F
              Использование акта завершения хранения
   Long       storageTime;              //STORAGE_TIME                          Срок хранения
   String     clientId;                 //CLIENT_ID
              Идентификатор клиента для интеграции с 1С
   String     tmStructId;               //TM_STRUCT_ID
              Узел отгрузки SAP TM. При наличии отображаем номер фрахтового заказа.
   Boolean    notUseShippingContainer;  //NOT_USE_SHIPPING_CONTAINER    F
              Не активны в модальном окне оформления отгрузки поля:
                № контейнера, № пломбы, Дата погрузки в контейнер
   Boolean    useShippingVehicleOnly;   //USE_SHIPPING_VEHICLE_ONLY     F
              Использование только № ТС и даты факт. отгрузки в модальном окне оформления отгрузки
   Boolean    useCheckShiptoAddress;    //USE_CHECK_SHIPTO_ADDRESS      F
              Использовать блокировку на создание МХ-3 и АЗХ если в акте УЕ
              с разными адресами грузополучателя
   Boolean    useBuyoutWithTtn;         //USE_BUYOUT_WITH_TTN           F
              Отгрузка/выкуп ГП по ТН со складов ОХ/переработчиков
   Boolean    ttnAttachmentRequired;    //TTN_ATTACHMENT_REQUIRED       F
              Требуется прикрепить ТН
   String     stockType;                //STOCK_TYPE
              Признак типа склада - ГП/ПФ
   Long       storageCost;              //STORAGECOST
              Цена хранения
   String     priceType;                //PRICETYPE
              Тип цены (За тонну выкупленного - "TON"
                        За тонну в месяц - "MON"
                        За тонну в сутки - "DAY")
   Long       waterDeliveryPrice;       //WATERDELIVERYPRICE
              Стоимость доставки до мест хранения
   Boolean    useProhibitionShipping    //USE_PROHIBITION_SHIPPING
              Использовать запрет на отгрузку заказа
   Boolean    useMhOnExpeditor;         //USE_MH_ON_EXPEDITOR           F
              Использовать МХ-1/МХ-3 на экспедиторе
   String     contractNum;              //CONTRACT_NUM
              Номер договора системный
   String     contractNoLog;            //CONTRACT_NO_LOG
              Номер договора юридический
   LocalDate  contractDate;             //CONTRACT_DATE                         Дата договора
   LocalDate  contractEndDate;          //CONTRACT_END_DATE
              Дата окончания действия договора
   Boolean    useCreditLimitCheck;      //USE_CREDIT_LIMIT_CHECK        F
              Использовать проверку кредитных лимитов перед оформлением МХ-3
   Boolean    useDZCheck;               //USE_DZ_CHECK                  F
              Использовать проверку допустимой дебиторской задолженности перед оформлением МХ-3
   Boolean    usePDZCheck;              //USE_PDZ_CHECK                 F
              Использовать проверку просроченной дебиторской задолженности перед оформлением МХ-3
   Boolean    usePlacingRollsInCarBody  //USE_PLACING_ROLLS_IN_CAR_BODY
              Расположение рулонов в кузове авто
   Boolean    useProductionLg           //USE_PRODUCTION_LG             F
              Настройка Производства ЛГ (Лишний годный)
   Long       holderReportDay;          //HOLDER_REPORT_DAY
              Дата формирования отчета хранителя
   Boolean    useSZRebinding            //USE_SZ_REBINDING              F
              Использовать перепривязку СЗ
   Boolean    useBlockingMH3            //USE_BLOCKING_MH3              F
              Блокировать создание акта МХ-3 (склады ОХ)
   Boolean    isOffBalanceSheet;        //IS_OFF_BALANCE_SHEET          F
              Склад забалансовый
   Boolean    useShippingFromSAP;      //USE_SHIPPING_FROM_SAP          F
              Обрабатывать отгрузку из SAP
   Boolean    useSZWorking             //USE_SZ_WORKING                 F
              Отображать вкладку Заказы (Работа с СЗ)
   Boolean    printQcFromQmet          //PRINT_QC_FROM_QMET                     Печатать СК из QMET
   Boolean    printQcFromStorage       //PRINT_QC_FROM_STORAGE
              Печатать СК из хранилища
   Boolean    isHub;                    //IS_HUB                                Склад является хабом
   Boolean    autoOrderSigning          //AUTO_ORDER_SIGNING
              Автоподписание заказа на переработку
   Boolean    useFactWeight             //USE_FACT_WEIGHT
              Вес с производства по фактическому весу
   Boolean    useQcGenerationShipment   //USE_QC_GENERATION_SHIPMENT
              Формировать СК при отгрузке (для переработчиков)
   Boolean    useSetContractBuyout      //USE_SET_CONTRACT_BUYOUT
              Выбор договора при оформлении выкупа
   Boolean    useTtnCreate              //USE_TTN_CREATE                        Создание ТН
   Boolean    usePartialConfirm         //USE_PARTIAL_CONFIRM
              Частичное подтверждение/сторно
   Boolean    useCheckSeparation;       //USE_CHECK_SEPARATION
              Проверять сепарацию при отгрузке
   Boolean    useClientArrivalDate;     //USE_CLIENT_ARRIVAL_DATE
              Дата фактического прибытия груза

   Настройки печатной формы ТН:
   1 Заказчик услуг по организации перевозки груза (при наличии):
   String     contractNoTtn;            //CONTRACT_NO_TTN                       Договор
   LocalDate  contractDateTtn;          //CONTRACT_DATE_TTN                     Дата договора

   8 Прием груза:
   String     loader;                   //LOADER
              Наименование (ИНН) владельца объекта инфраструктуры пункта погрузки
   String     loaderDetails;            //LOADER_DETAILS
              Реквизиты лица, осуществляющего погрузку груза в транспортное средство
   String     loaderAddress;            //LOADER_ADDRESS
              Адрес места погрузки
   Boolean    checkDifferentShipmentMode;//CHECK_DIFFERENT_SHIPMENT_MODE   T
   Проверка на разные способы отгрузки
   */

  const onValueChangedSettings = useCallback((value, settingId) => {
    setSettingsPlant({
      plant: plantId,
      settingId,
      value
    });
    if (userReducer.id !== null) {
      fetchStock({ id: userReducer.id });
    }
  }, [userReducer.id, setSettingsPlant, plantId, fetchStock]);

  const calculateChangedSettingsOptional = useCallback((value, settingId) => {
    // eslint-disable-next-line no-shadow
    let changeSettings = true;
    if (settingId === 'useM15B' && value && data.useM15Incoming !== value) {
      modalErrorOpen({
        message: formatMessage('textError').useM15BWithoutM15,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      onValueChangedSettings(value, 'useM15Incoming');
      changeSettings = false;
    }
    if (settingId === 'useMC' && value && data.stockType !== '') {
      modalErrorOpen({
        message: formatMessage('textError').useMCnotFTO,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      setData({
        ...data,
        useMC: false
      });
      changeSettings = false;
    }
    if (settingId === 'stockType' && value && value !== '' && data.useMC) {
      modalErrorOpen({
        message: formatMessage('textError').useMCnotFTO,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      setData({
        ...data,
        stockType: ''
      });
      changeSettings = false;
    }
    if (settingId === 'ttnAttachmentRequired' && value && data.useBuyoutWithTtn === false) {
      modalErrorOpen({
        message: formatMessage('textError').useWithBuyoutWithTtn,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      setData({
        ...data,
        ttnAttachmentRequired: false
      });
      changeSettings = false;
    }
    if ((settingId === 'printQcFromQmet' && !value && data.printQcFromStorage === false)
      || (settingId === 'printQcFromStorage' && !value && data.printQcFromQmet === false)) {
      modalErrorOpen({
        message: formatMessage('texterror').mustSelectPrintQCSource,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      if (settingId === 'printQcFromQmet') {
        setData({
          ...data,
          printQcFromQmet: true
        });
      } else {
        setData({
          ...data,
          printQcFromStorage: true
        });
      }
    }
    if (settingId === 'useTtnCreate') {
      if (value) {
        setVisibleModalSettingsTN(value);
        changeSettings = false;
      } else {
        setVisibleFieldsSettingsTN(false);
      }
    }
    if (settingId === 'usePriorityExportEmail') {
      setVisiblePriorityExport(value);
    }
    if ((settingId === 'priority1ShippingDays' && value <= data.priority2ShippingDays)
      || (settingId === 'priority2ShippingDays' && value >= data.priority1ShippingDays)) {
      modalErrorOpen({
        message: formatMessage('textError').setRealPriorityShippingDays,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
      changeSettings = false;
    }
    if (changeSettings) {
      onValueChangedSettings(value, settingId);
    }
  }, [data, modalErrorOpen, onValueChangedSettings]);

  const calculateChangedSettings = useCallback((curVal, value, settingId) => {
    if (value) {
      calculateChangedSettingsOptional(curVal, settingId);
    } else {
      onValueChangedSettings('', settingId);
    }
  }, [calculateChangedSettingsOptional, onValueChangedSettings]);

  const DocNoteRender = useCallback(() => (
    <TextBox value={data.docNote}
             stylingMode="filled"
             placeholder="Введите примечание к документу"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               docNote: value
             }))}
             showClearButton
    />
  ), [data.docNote]);

  const ExecutorIdSapRender = useCallback(() => (
    <TextBox value={data.executorIdSap}
             stylingMode="filled"
             placeholder="Введите исполнителя в ZDVL - заказе"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               executorIdSap: value
             }))}
             showClearButton
    />
  ), [data.executorIdSap]);

  const ClientIdRender = useCallback(() => (
    <TextBox value={data.clientId}
             stylingMode="filled"
             placeholder="Введите id клиента для интеграции с 1с"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               clientId: value
             }))}
             showClearButton
    />
  ), [data.clientId]);

  const TmStructIdRender = useCallback(() => (
    <TextBox value={data.tmStructId}
             stylingMode="filled"
             placeholder="Введите узел SAP TM"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               tmStructId: value
             }))}
             showClearButton
      />
  ), [data.tmStructId]);

  const AutoAcceptIncomingRender = useCallback(() => (
    <Switch defaultValue={data.autoAcceptIncoming}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'autoAcceptIncoming')}
    />
  ), [data.autoAcceptIncoming, onValueChangedSettings]);
  const AutoSignIncomingRender = useCallback(() => (
    <Switch defaultValue={data.autoSignIncoming}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'autoSignIncoming')}
    />
  ), [data.autoSignIncoming, onValueChangedSettings]);
  const FlowModelRender = useCallback(() => (
    <Switch defaultValue={data.flowModel}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'flowModel')}
    />
  ), [data.flowModel, onValueChangedSettings]);
  const UseM15IncomingRender = useCallback(() => (
    <Switch defaultValue={data.useM15Incoming}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useM15Incoming')}
    />
  ), [data.useM15Incoming, onValueChangedSettings]);
  const UseM15BRender = useCallback(() => (
    <Switch defaultValue={data.useM15B}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'useM15B')}
    />
  ), [data.useM15B, calculateChangedSettingsOptional]);
  const UseM4Render = useCallback(() => (
    <Switch defaultValue={data.useM4}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useM4')}
  />
  ), [data.useM4, onValueChangedSettings]);

  const UseMCRender = useCallback(() => (
    <Switch defaultValue={data.useMC}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'useMC')}
    />
  ), [data.useMC, calculateChangedSettingsOptional]);

  const UseFIFORender = useCallback(() => (
    <Switch defaultValue={data.useFIFO}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useFIFO')}
    />
  ), [data.useFIFO, onValueChangedSettings]);

  const UseAZHRender = useCallback(() => (
    <Switch defaultValue={data.useAZH}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useAZH')}
    />
  ), [data.useAZH, onValueChangedSettings]);

  const UseOverrideContract = useCallback(() => (
      <Switch defaultValue={data.overrideContract}
              onValueChanged={({ value }) => onValueChangedSettings(value, 'overrideContract')}
      />
  ), [data.overrideContract, onValueChangedSettings]);

  const NotUseShippingContainerRender = useCallback(() => (
    <Switch defaultValue={data.notUseShippingContainer}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'notUseShippingContainer')}
    />
  ), [data.notUseShippingContainer, onValueChangedSettings]);

  const UseShippingVehicleOnlyRender = useCallback(() => (
    <Switch defaultValue={data.useShippingVehicleOnly}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'useShippingVehicleOnly')}
    />
  ), [data.useShippingVehicleOnly, calculateChangedSettingsOptional]);

  const UseCheckShiptoAddressRender = useCallback(() => (
    <Switch defaultValue={data.useCheckShiptoAddress}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useCheckShiptoAddress')}
    />
  ), [data.useCheckShiptoAddress, onValueChangedSettings]);

  const UseBuyoutWithTtnRender = useCallback(() => (
    <Switch defaultValue={data.useBuyoutWithTtn}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useBuyoutWithTtn')}
    />
  ), [data.useBuyoutWithTtn, onValueChangedSettings]);

  const TtnAttachmentRequiredRender = useCallback(() => (
    <Switch defaultValue={data.ttnAttachmentRequired}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'ttnAttachmentRequired')}
    />
  ), [data.ttnAttachmentRequired, calculateChangedSettingsOptional]);

  const UseStockSemiRender = useCallback(() => (
    <Switch defaultValue={data.stockType === 'semi'}
            onValueChanged={({ value }) => calculateChangedSettings('semi', value, 'stockType')}
    />
  ), [calculateChangedSettings, data.stockType]);

  const UseSZRebindingRender = useCallback(() => (
    <Switch defaultValue={data.useSZRebinding}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useSZRebinding')}
    />
  ), [onValueChangedSettings, data.useSZRebinding]);

  const UseBlockingMH3Render = useCallback(() => (
    <Switch defaultValue={data.useBlockingMH3}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useBlockingMH3')}
    />
  ), [onValueChangedSettings, data.useBlockingMH3]);

  const UsePlacingRollsInCarBodyRender = useCallback(() => (
    <Switch defaultValue={data.usePlacingRollsInCarBody}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'usePlacingRollsInCarBody')}
    />
  ), [data.usePlacingRollsInCarBody, onValueChangedSettings]);

  const UseProductionLgRender = useCallback(() => (
    <Switch defaultValue={data.useProductionLg}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useProductionLg')}
    />
  ), [data.useProductionLg, onValueChangedSettings]);

  const UseShippingFromSAPRender = useCallback(() => (
    <Switch defaultValue={data.useShippingFromSAP}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useShippingFromSAP')}
    />
  ), [onValueChangedSettings, data.useShippingFromSAP]);

  const UseStockReadyRender = useCallback(() => (
    <Switch defaultValue={data.stockType === 'ready'}
            onValueChanged={({ value }) => calculateChangedSettings('ready', value, 'stockType')}
    />
  ), [calculateChangedSettings, data.stockType]);

  const UseCreditLimitCheckRender = useCallback(() => (
    <Switch defaultValue={data.useCreditLimitCheck}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useCreditLimitCheck')}
    />
  ), [data.useCreditLimitCheck, onValueChangedSettings]);

  const UseDZCheckRender = useCallback(() => (
    <Switch defaultValue={data.useDZCheck}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useDZCheck')}
    />
  ), [data.useDZCheck, onValueChangedSettings]);

  const UsePDZCheckRender = useCallback(() => (
    <Switch defaultValue={data.usePDZCheck}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'usePDZCheck')}
    />
  ), [data.usePDZCheck, onValueChangedSettings]);

  const UseSZWorkingRender = useCallback(() => (
    <Switch defaultValue={data.useSZWorking}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useSZWorking')}
    />
  ), [data.useSZWorking, onValueChangedSettings]);

  const PrintQcFromQmetRender = useCallback(() => (
    <Switch defaultValue={data.printQcFromQmet}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'printQcFromQmet')}
    />
  ), [data.printQcFromQmet, calculateChangedSettingsOptional]);

  const PrintQcFromStorageRender = useCallback(() => (
    <Switch defaultValue={data.printQcFromStorage}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'printQcFromStorage')}
    />
  ), [data.printQcFromStorage, calculateChangedSettingsOptional]);

  const UseSetContractBuyoutRender = useCallback(() => (
    <Switch defaultValue={data.useSetContractBuyout}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useSetContractBuyout')}
    />
  ), [data.useSetContractBuyout, onValueChangedSettings]);

  const UseStorageLevelsRender = useCallback(() => (
    <Switch defaultValue={data.useStorageLevels}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useStorageLevels')}
    />
  ), [data.useStorageLevels, onValueChangedSettings]);

  const UseShowSemiAttrbRender = useCallback(() => (
    <Switch defaultValue={data.showSemiAttrb}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'showSemiAttrb')}
    />
  ), [data.showSemiAttrb, onValueChangedSettings]);

  const openModalMessage = useCallback(() => {
    modalMessageOpen({
      isEditing: true,
      modalShippingType: shippingType
    });
  }, [modalMessageOpen, shippingType]);

  /** параметры для holder_report */
  const renderStorageCost = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите цену хранения"
               value={valueStorageCost}
               onValueChanged={onValueChangedStorageCost}
               width={300}
               showClearButton
    />
  ), [onValueChangedStorageCost, valueStorageCost]);

  const renderOverStorageCost = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите цену сверхнормативного хранения"
               value={valueOverStorageCost}
               onValueChanged={onValueChangedOverStorageCost}
               width={300}
               showClearButton
    />
  ), [onValueChangedOverStorageCost, valueOverStorageCost]);

  const UsePriceTypeTon = useCallback(() => (
    <Switch defaultValue={data.priceType === 'TON'}
            onValueChanged={({ value }) => calculateChangedSettings('TON', value, 'priceType')}
    />
  ), [calculateChangedSettings, data.priceType]);

  const UsePriceTypeMon = useCallback(() => (
    <Switch defaultValue={data.priceType === 'MON'}
            onValueChanged={({ value }) => calculateChangedSettings('MON', value, 'priceType')}
    />
  ), [calculateChangedSettings, data.priceType]);

  const UsePriceTypeDay = useCallback(() => (
    <Switch defaultValue={data.priceType === 'DAY'}
            onValueChanged={({ value }) => calculateChangedSettings('DAY', value, 'priceType')}
    />
  ), [calculateChangedSettings, data.priceType]);

  const renderWaterDeliveryPrice = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите стоимость доставки до мест хранения"
               value={valueWaterDeliveryPrice}
               onValueChanged={onValueChangedWaterDeliveryPrice}
               width={300}
               showClearButton
    />
  ), [onValueChangedWaterDeliveryPrice, valueWaterDeliveryPrice]);

  const UseProhibitionShippingRender = useCallback(() => (
    <Switch defaultValue={data.useProhibitionShipping}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useProhibitionShipping')}
    />
  ), [data.useProhibitionShipping, onValueChangedSettings]);

  const UseMhOnExpeditorRender = useCallback(() => (
    <Switch defaultValue={data.useMhOnExpeditor}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useMhOnExpeditor')}
    />
  ), [data.useMhOnExpeditor, onValueChangedSettings]);

  const ContractNumRender = useCallback(() => (
    <TextBox value={data.contractNum}
             stylingMode="filled"
             placeholder="Введите номер договора системный"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractNum: value
             }))}
             showClearButton
    />
  ), [data.contractNum]);

  const ContractNoLogRender = useCallback(() => (
    <TextBox value={data.contractNoLog}
             stylingMode="filled"
             placeholder="Введите номер договора юридический"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractNoLog: value
             }))}
             showClearButton
    />
  ), [data.contractNoLog]);

  const ContractDateRender = useCallback(() => (
    <DateBox type="date"
             value={data.contractDate}
             stylingMode="filled"
             // stylingMode="outlined"
             openOnFieldClick
             displayFormat="dd.MM.yyyy"
             dateSerializationFormat="yyyy-MM-dd"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractDate: value
             }))}
             showClearButton
    />
  ), [data.contractDate]);

  const ContractEndDateRender = useCallback(() => (
    <DateBox type="date"
             value={data.contractEndDate}
             stylingMode="filled"
            // stylingMode="outlined"
             openOnFieldClick
             displayFormat="dd.MM.yyyy"
             dateSerializationFormat="yyyy-MM-dd"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractEndDate: value
             }))}
             showClearButton
    />
  ), [data.contractEndDate]);

  const renderHolderReportDay = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Дата формирования отчета хранителя"
               value={valueHolderReportDay}
               onValueChanged={onValueChangedHolderReportDay}
               width={300}
               showClearButton
    />
  ), [onValueChangedHolderReportDay, valueHolderReportDay]);

  const renderPriority1ShippingDays = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите количество дней"
               value={priorityShippingDays.priority1ShippingDays || null}
               onValueChanged={({ value }) => onValueChangedPriorityShippingDays(value, 1)}
               width={300}
               showClearButton
    />
  ), [onValueChangedPriorityShippingDays, priorityShippingDays.priority1ShippingDays]);

  const renderPriority2ShippingDays = useMemo(() => (
    <NumberBox stylingMode="filled"
               placeholder="Введите количество дней"
               value={priorityShippingDays.priority2ShippingDays || null}
               onValueChanged={({ value }) => onValueChangedPriorityShippingDays(value, 2)}
               width={300}
               showClearButton
    />
  ), [onValueChangedPriorityShippingDays, priorityShippingDays.priority2ShippingDays]);

  const EmailsCopyPriorityExportRender = useCallback(() => (
    <TextBox
      value={data.emailsCopyPriorityExport}
      stylingMode="filled"
      placeholder="Введите получателя"
      width={600}
      onValueChanged={({ value }) => setData((item) => ({
        ...item,
        emailsCopyPriorityExport: value
      }))}
      showClearButton
    />
  ), [data.emailsCopyPriorityExport]);

  const IsHubRender = useCallback(() => (
    <Switch defaultValue={data.isHub}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'isHub')}
    />
  ), [data.isHub, onValueChangedSettings]);

  const AutoOrderSigningRender = useCallback(() => (
    <Switch defaultValue={data.autoOrderSigning}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'autoOrderSigning')}
    />
  ), [data.autoOrderSigning, onValueChangedSettings]);

  const UseFactWeightRender = useCallback(() => (
    <Switch defaultValue={data.useFactWeight}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useFactWeight')}
    />
  ), [data.useFactWeight, onValueChangedSettings]);

  const UseQcGenerationShipmentRender = useCallback(() => (
    <Switch defaultValue={data.useQcGenerationShipment}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useQcGenerationShipment')}
    />
  ), [data.useQcGenerationShipment, onValueChangedSettings]);

  const UseTtnCreateRender = useCallback(() => (
    <Switch defaultValue={data.useTtnCreate}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'useTtnCreate')}
    />
  ), [data.useTtnCreate, calculateChangedSettingsOptional]);

  const UsePartialConfirmRender = useCallback(() => (
    <Switch defaultValue={data.usePartialConfirm}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'usePartialConfirm')}
    />
  ), [data.usePartialConfirm, onValueChangedSettings]);

  const AutoConfirmIntegrProductionRender = useCallback(() => (
    <Switch defaultValue={data.autoConfirmIntegrProduction}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'autoConfirmIntegrProduction')}
    />
  ), [data.autoConfirmIntegrProduction, onValueChangedSettings]);

  const UseCheckSeparationRender = useCallback(() => (
    <Switch defaultValue={data.useCheckSeparation}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useCheckSeparation')}
    />
  ), [data.useCheckSeparation, onValueChangedSettings]);

  const UseClientArrivalDate = useCallback(() => (
    <Switch defaultValue={data.useClientArrivalDate}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useClientArrivalDate')}
    />
  ), [data.useClientArrivalDate, onValueChangedSettings]);

  const UseCheckUsePriorityExportEmail = useCallback(() => (
    <Switch defaultValue={data.usePriorityExportEmail}
            onValueChanged={({ value }) => calculateChangedSettingsOptional(value, 'usePriorityExportEmail')}
    />
  ), [calculateChangedSettingsOptional, data.usePriorityExportEmail]);

  const UseZdvlNewEmail = useCallback(() => (
    <Switch defaultValue={data.useZdvlNewEmail}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useZdvlNewEmail')}
    />
  ), [data.useZdvlNewEmail, onValueChangedSettings]);

  const UseZdvlSignEmail = useCallback(() => (
    <Switch defaultValue={data.useZdvlSignEmail}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'useZdvlSignEmail')}
    />
  ), [data.useZdvlSignEmail, onValueChangedSettings]);

  const CheckDifferentShipmentModeRender = useCallback(() => (
    <Switch defaultValue={data.checkDifferentShipmentMode}
            onValueChanged={({ value }) => onValueChangedSettings(value, 'checkDifferentShipmentMode')}
    />
  ), [data.checkDifferentShipmentMode, onValueChangedSettings]);

  const UseShippingDocumentFromSap = useCallback(() => (
      <Switch defaultValue={data.useShippingDocumentFromSap}
              onValueChanged={({ value }) => onValueChangedSettings(value, 'useShippingDocumentFromSap')}
      />
  ), [data.useShippingDocumentFromSap, onValueChangedSettings]);


  /* Поля для настройки печатной формы ТН */

  const ContractNoTtnRender = useCallback(() => (
    <TextBox value={data.contractNoTtn}
             stylingMode="filled"
             placeholder="Введите номер договора"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractNoTtn: value
             }))}
             showClearButton
    />
  ), [data.contractNoTtn]);

  const ContractDateTNRender = useCallback(() => (
    <DateBox type="date"
             value={data.contractDateTtn}
             stylingMode="filled"
      // stylingMode="outlined"
             openOnFieldClick
             displayFormat="dd.MM.yyyy"
             dateSerializationFormat="yyyy-MM-dd"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               contractDateTtn: value
             }))}
             showClearButton
    />
  ), [data.contractDateTtn]);

  const LoaderRender = useCallback(() => (
    <TextBox value={data.loader}
             stylingMode="filled"
             placeholder="Введите наименование (ИНН) владельца объекта инфраструктуры пункта погрузки"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               loader: value
             }))}
             showClearButton
    />
  ), [data.loader]);

  const LoaderDetailsRender = useCallback(() => (
    <TextBox value={data.loaderDetails}
             stylingMode="filled"
             placeholder="Введите реквизиты лица, осуществляющего погрузку груза в транспортное средство"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               loaderDetails: value
             }))}
             showClearButton
    />
  ), [data.loaderDetails]);

  const LoaderAddressRender = useCallback(() => (
    <TextBox value={data.loaderAddress}
             stylingMode="filled"
             placeholder="Введите адрес места погрузки"
             width={300}
             onValueChanged={({ value }) => setData((item) => ({
               ...item,
               loaderAddress: value
             }))}
             showClearButton
    />
  ), [data.loaderAddress]);

  const EmailsForZdvlNewRender = useCallback(() => (
    <TextBox
      value={data.emailsForZdvlNew}
      stylingMode="filled"
      placeholder="Введите получателя"
      width={600}
      onValueChanged={({ value }) => setData((item) => ({
        ...item,
        emailsForZdvlNew: value
      }))}
      showClearButton
    />
  ), [data.emailsForZdvlNew]);

  const EmailsCopyForZdvlNewRender = useCallback(() => (
    <TextBox
      value={data.emailsCopyForZdvlNew}
      stylingMode="filled"
      placeholder="Введите получателя"
      width={600}
      onValueChanged={({ value }) => setData((item) => ({
        ...item,
        emailsCopyForZdvlNew: value
      }))}
      showClearButton
    />
  ), [data.emailsCopyForZdvlNew]);

  const EmailsForZdvlSignRender = useCallback(() => (
    <TextBox
      value={data.emailsForZdvlSign}
      stylingMode="filled"
      placeholder="Введите получателя"
      width={600}
      onValueChanged={({ value }) => setData((item) => ({
        ...item,
        emailsForZdvlSign: value
      }))}
      showClearButton
    />
  ), [data.emailsForZdvlSign]);

  const EmailsCopyForZdvlSignRender = useCallback(() => (
    <TextBox
      value={data.emailsCopyForZdvlSign}
      stylingMode="filled"
      placeholder="Введите получателя"
      width={600}
      onValueChanged={({ value }) => setData((item) => ({
        ...item,
        emailsCopyForZdvlSign: value
      }))}
      showClearButton
    />
  ), [data.emailsCopyForZdvlSign]);

  const closeModalTNSettings = useCallback(() => {
    setVisibleModalSettingsTN(false);
    setVisibleFieldsSettingsTN(true);
  }, []);

  const saveSettingsTN = useCallback(() => {
    setSettingsTNPlant({
      plant: plantId,
      settingsTN: {
        contractNoTtn: data.contractNoTtn,
        contractDateTtn: data.contractDateTtn,
        loader: data.loader,
        loaderDetails: data.loaderDetails,
        loaderAddress: data.loaderAddress,
        useTtnCreate: !data.useTtnCreate
      }
    });
    // if (userReducer.id !== null) {
    //   fetchStock({ id: userReducer.id });
    // }
  },
  [
    data.contractDateTtn,
    data.contractNoTtn,
    data.loader,
    data.loaderAddress,
    data.loaderDetails,
    data.useTtnCreate,
    plantId,
    setSettingsTNPlant
  ]);

  const renderSettingsTN = useMemo(() => (
    <fieldset style={{ display: visibleFieldsSettingsTN ? 'block' : 'none' }}>
      <legend>Настройки печатной формы ТН</legend>
      <div>
        <span>1 Заказчик услуг по организации перевозки груза (при наличии)</span>
        <div className={style.line}>
          <span>Договор:</span>
          <ContractNoTtnRender />
        </div>
        <div className={style.line}>
          <span>Дата договора:</span>
          <ContractDateTNRender />
        </div>
        <span>8 Прием груза</span>
        <div className={style.line}>
          <span>Наименование (ИНН) владельца объекта инфраструктуры пункта погрузки:</span>
          <LoaderRender />
        </div>
        <div className={style.line}>
          <span>Реквизиты лица, осуществляющего погрузку груза в транспортное средство:</span>
          <LoaderDetailsRender />
        </div>
        <div className={style.line}>
          <span>Адрес места погрузки:</span>
          <LoaderAddressRender />
        </div>
        <div className="formSaveButton">
          <Button type="default"
                  stylingMode="text"
                  text="Сохранить"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={saveSettingsTN}
          />
        </div>
      </div>
    </fieldset>
  ), [saveSettingsTN, visibleFieldsSettingsTN]);

  return (
    <>
      <div className={style.containing}>
        <LoadIndicator className={style.loader} visible={loading} />
        <div className={style.line}>
          <span>Срок хранения:</span>
          { renderNumber }
          <Button type="default"
                  stylingMode="text"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={() => onValueChangedSettings(valueStorageTime, 'storageTime')}
          />
        </div>
        <div className={style.line}>
          <span>Автоматическое создание МХ-1 и М-15:</span>
          <AutoAcceptIncomingRender />
        </div>
        <div className={style.line}>
          <span>Автоматическая ПЭП:</span>
          <AutoSignIncomingRender />
        </div>
        <div className={style.line}>
          <span>Примечание к документу:</span>
          <DocNoteRender />
          <Button type="default"
                  stylingMode="text"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={() => onValueChangedSettings(data.docNote, 'docNote')}
          />
        </div>
        <div className={style.line}>
          <span>Исполнитель в ZDVL - заказе:</span>
          <ExecutorIdSapRender />
          <Button type="default"
                  stylingMode="text"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={() => onValueChangedSettings(data.executorIdSap, 'executorIdSap')}
          />
        </div>
        <div className={style.line}>
          <span>Признак поточной модели:</span>
          <FlowModelRender />
        </div>
        <div className={style.line}>
          <span>Узел отгрузки SAP TM. Если заполнен, отображаем номер фрахтового заказа.:</span>
          <TmStructIdRender />
          <Button type="default"
                  stylingMode="text"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={() => onValueChangedSettings(data.tmStructId, 'tmStructId')}
          />
        </div>
        <div className={style.line}>
          <span>Использование М-4:</span>
          <UseM4Render />
        </div>
        <div className={style.line}>
          <span>Использование мастер-рулонов:</span>
          <UseMCRender />
        </div>
        <div className={style.line}>
          <span>Склад ГП:</span>
          <UseStockReadyRender />
        </div>
        <div className={style.line}>
          <span>Склад ПФ:</span>
          <UseStockSemiRender />
        </div>
        <div className={style.line}>
          <span>Кнопка Перепривязка СЗ:</span>
          <UseSZRebindingRender />
        </div>
        <div className={style.line}>
          <span>Вкладка - Заказы:</span>
          <UseSZWorkingRender />
        </div>
        <div className={style.line}>
          <span>Блокировка создания акта МХ-3 (склады ОХ):</span>
          <UseBlockingMH3Render />
        </div>
        {settings && settings.stockType === 'semi' && (
        <div className={style.line}>
          <span>Производство ЛГ:</span>
          <UseProductionLgRender />
        </div>
        )}
        <div className={style.line}>
          <span>Использование АКТа о завершении хранения:</span>
          <UseAZHRender />
        </div>
        <div className={style.line}>
            <span>Переопределить договор в ПФ документов:</span>
            <UseOverrideContract />
        </div>
        <div className={style.line}>
            <span>Номер договора системный:</span>
            <ContractNumRender />
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    elementAttr={{ class: style.button }}
                    onClick={() => onValueChangedSettings(data.contractNum, 'contractNum')}
            />
        </div>
        <div className={style.line}>
            <span>Номер договора юридический:</span>
            <ContractNoLogRender />
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    elementAttr={{ class: style.button }}
                    onClick={() => onValueChangedSettings(data.contractNoLog, 'contractNoLog')}
            />
        </div>
        <div className={style.line}>
            <span>Дата договора:</span>
            <ContractDateRender />
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    elementAttr={{ class: style.button }}
                    onClick={() => onValueChangedSettings(data.contractDate, 'contractDate')}
            />
        </div>
        <div className={style.line}>
            <span>Дата окончания действия договора:</span>
            <ContractEndDateRender />
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    elementAttr={{ class: style.button }}
                    onClick={() => onValueChangedSettings(data.contractEndDate, 'contractEndDate')}
            />
        </div>
        {(shippingType === 0) ? (
          <>
            <div className={style.line}>
              <span>Не использование контейнеров при отгрузке:</span>
              <NotUseShippingContainerRender />
            </div>
            <div className={style.line}>
              <span>Использование только № ТС и даты фактической отгрузки:</span>
              <UseShippingVehicleOnlyRender />
            </div>
            <div className={style.line}>
              <span>Использовать МХ-1/МХ-3 на экспедиторе:</span>
              <UseMhOnExpeditorRender />
            </div>
            <div className={style.line}>
              <span>Создание ТН:</span>
              <UseTtnCreateRender />
            </div>
            <div>
              { renderSettingsTN }
            </div>
            <div className={style.line}>
              <span>Проверять сепарацию при отгрузке:</span>
              <UseCheckSeparationRender />
            </div>
            <div className={style.line}>
              <span>Дата фактического прибытия груза</span>
              <UseClientArrivalDate />
            </div>
            <fieldset>
              <legend>&#34;Приоритетный вывоз позиций&#34;</legend>
              <div className={style.line}>
                <span>Рассылка:</span>
                <UseCheckUsePriorityExportEmail />
              </div>
              <div style={{ display: visiblePriorityExport ? 'block' : 'none' }}>
                <div className={style.line}>
                  <span>Приоритет 1:</span>
                  { renderPriority1ShippingDays }
                  <Button type="default"
                          stylingMode="text"
                          icon="save"
                          elementAttr={{ class: style.button }}
                          onClick={() => calculateChangedSettingsOptional(priorityShippingDays.priority1ShippingDays, 'priority1ShippingDays')}
                  />
                </div>
                <div className={style.line}>
                  <span>Приоритет 2:</span>
                  { renderPriority2ShippingDays }
                  <Button type="default"
                          stylingMode="text"
                          icon="save"
                          elementAttr={{ class: style.button }}
                          onClick={() => calculateChangedSettingsOptional(priorityShippingDays.priority2ShippingDays, 'priority2ShippingDays')}
                  />
                </div>
                <div className={style.line}>
                  <span>Получатели:</span>
                  <EmailsCopyPriorityExportRender />
                  <Button type="default"
                          stylingMode="text"
                          icon="save"
                          elementAttr={{ class: style.button }}
                          onClick={() => onValueChangedSettings(data.emailsCopyPriorityExport, 'emailsCopyPriorityExport')}
                  />
                </div>
              </div>
            </fieldset>
            <div className={style.line}>
              <span>Расположение рулонов в кузове авто:</span>
              <UsePlacingRollsInCarBodyRender />
            </div>
          </>
        ) : (
          <>
            <div className={style.line}>
              <span>Использовать блокировку на создание МХ-3 и АЗХ,</span>
              <span>если в акте УЕ с разными адресами грузополучателя:</span>
              <UseCheckShiptoAddressRender />
            </div>
            <div className={style.line}>
              <span>Отгрузка/выкуп ГП по ТН со складов ОХ/переработчиков:</span>
              <UseBuyoutWithTtnRender />
            </div>
            <div className={style.line}>
              <span>Требуется прикрепить ТН:</span>
              <TtnAttachmentRequiredRender />
            </div>
          </>
        )}
        <div className={style.line}>
          <span>Идентификатор клиента для интеграции с 1С:</span>
          <ClientIdRender />
          <Button type="default"
                  stylingMode="text"
                  icon="save"
                  elementAttr={{ class: style.button }}
                  onClick={() => onValueChangedSettings(data.clientId, 'clientId')}
          />
        </div>
        {(shippingType === 1) ? (
          <>
            <div className={style.line}>
              <span>Дата фактического прибытия груза</span>
              <UseClientArrivalDate />
            </div>
            <fieldset>
              <legend>Настройки отчёта хранителя</legend>
              <div className={style.line}>
                <span>Цена хранения:</span>
                { renderStorageCost }
                <Button type="default"
                      stylingMode="text"
                      icon="save"
                      elementAttr={{ class: style.button }}
                      onClick={() => onValueChangedSettings(valueStorageCost, 'storageCost')}
              />
              </div>
              <div className={style.line}>
                <span>Цена сверхнормативного хранения:</span>
                { renderOverStorageCost }
                <Button type="default"
                        stylingMode="text"
                        icon="save"
                        elementAttr={{ class: style.button }}
                        onClick={() => onValueChangedSettings(valueOverStorageCost, 'overStorageCost')}
                />
              </div>
              <div className={style.line}>
                <span><b>Тип цены</b></span>
              </div>
              <div className={style.line}>
                <span>За тонну выкупленного:</span>
                <UsePriceTypeTon />
              </div>
              <div className={style.line}>
                <span>За тонну в месяц:</span>
                <UsePriceTypeMon />
              </div>
              <div className={style.line}>
                <span>За тонну в сутки:</span>
                <UsePriceTypeDay />
              </div>
              <div className={style.line}>
                <span>Стоимость доставки до мест хранения:</span>
                { renderWaterDeliveryPrice }
                <Button type="default"
                      stylingMode="text"
                      icon="save"
                      elementAttr={{ class: style.button }}
                      onClick={() => onValueChangedSettings(valueWaterDeliveryPrice, 'waterDeliveryPrice')}
                />
              </div>
              <div className={style.line}>
                <span>Дата формирования отчета хранителя:</span>
                { renderHolderReportDay }
                <Button type="default"
                    stylingMode="text"
                    icon="save"
                    elementAttr={{ class: style.button }}
                    onClick={() => onValueChangedSettings(valueHolderReportDay, 'holderReportDay')}
            />
              </div>
            </fieldset>
            <div className={style.line}>
              <span>Склад является хабом:</span>
              <IsHubRender />
            </div>
            <div className={style.line}>
                <span>Обрабатывать отгрузку из SAP:</span>
                <UseShippingFromSAPRender />
            </div>
            <div className={style.line}>
                <span>Создавать документ отгрузки/выкупа из SAP:</span>
                <UseShippingDocumentFromSap />
            </div>
          </>
        ) : ''}
        {(shippingType === 2) ? (
          <>
            <div className={style.line}>
              <span>Создавать М-15 при приемке:</span>
              <UseM15IncomingRender />
            </div>
            <div className={style.line}>
              <span>Создавать М-15В при выкупе:</span>
              <UseM15BRender />
            </div>
            <div className={style.line}>
              <span>Обрабатывать отгрузку из SAP:</span>
              <UseShippingFromSAPRender />
            </div>
            <div className={style.line}>
                <span>Создавать документ отгрузки/выкупа из SAP:</span>
                <UseShippingDocumentFromSap />
            </div>
            <div className={style.line}>
              <span>Автоподписание заказа на переработку:</span>
              <AutoOrderSigningRender />
            </div>
            <div className={style.line}>
              <span>Вес с производства по фактическому весу:</span>
              <UseFactWeightRender />
            </div>
            <div className={style.line}>
              <span>Формировать СК при отгрузке:</span>
              <UseQcGenerationShipmentRender />
            </div>
            <div className={style.line}>
              <span>Частичное подтверждение/сторно:</span>
              <UsePartialConfirmRender />
            </div>
            <div className={style.line}>
              <span>Автоматически подтверждать ГП через интеграцию:</span>
              <AutoConfirmIntegrProductionRender />
            </div>
            {
              settings.stockType === 'semi'
                ? (
                  <>
                    <fieldset className={data.useZdvlNewEmail ? '' : style.disabledFieldset}>
                      <div className={style.line}>
                        <span>Рассылка &#34;Передача заказа на переработку&#34;:</span>
                        <UseZdvlNewEmail />
                      </div>

                      { data.useZdvlNewEmail
                        ? (
                          <>
                            <div className={style.line}>
                              <span>Получатели:</span>
                              <EmailsForZdvlNewRender />
                              <Button type="default"
                                      stylingMode="text"
                                      icon="save"
                                      elementAttr={{ class: style.button }}
                                      onClick={() => onValueChangedSettings(data.emailsForZdvlNew, 'emailsForZdvlNew')}
                              />
                            </div>
                            <div className={style.line}>
                              <span>В копии:</span>
                              <EmailsCopyForZdvlNewRender />
                              <Button type="default"
                                      stylingMode="text"
                                      icon="save"
                                      elementAttr={{ class: style.button }}
                                      onClick={() => onValueChangedSettings(data.emailsCopyForZdvlNew, 'emailsCopyForZdvlNew')}
                              />
                            </div>
                          </>
                        )
                        : '' }
                    </fieldset>

                    <fieldset
                      className={data.useZdvlSignEmail ? '' : style.disabledFieldset}
                      style={data.useZdvlSignEmail ? { marginTop: '10px' } : {}}
                    >
                      <div className={style.line}>
                        <span>Рассылка &#34;Подписать заказа на переработку&#34;:</span>
                        <UseZdvlSignEmail />
                      </div>

                      { data.useZdvlSignEmail
                        ? (
                          <>
                            <div className={style.line}>
                              <span>Получатели:</span>
                              <EmailsForZdvlSignRender />
                              <Button type="default"
                                      stylingMode="text"
                                      icon="save"
                                      elementAttr={{ class: style.button }}
                                      onClick={() => onValueChangedSettings(data.emailsForZdvlSign, 'emailsForZdvlSign')}
                              />
                            </div>
                            <div className={style.line}>
                              <span>В копии:</span>
                              <EmailsCopyForZdvlSignRender />
                              <Button type="default"
                                      stylingMode="text"
                                      icon="save"
                                      elementAttr={{ class: style.button }}
                                      onClick={() => onValueChangedSettings(data.emailsCopyForZdvlSign, 'emailsCopyForZdvlSign')}
                              />
                            </div>
                          </>
                        )
                        : '' }
                    </fieldset>
                  </>
                )
                : ''
            }
          </>
        ) : (
          <>
            <div className={style.line}>
              <span>Использование принципа FIFO:</span>
              <UseFIFORender />
            </div>

            <fieldset>
              <legend>Оперативная кредитная проверка SAP</legend>
              <div className={style.line}>
                <span>Использование проверки кредитных лимитов (КЛ) перед оформлением МХ-3:</span>
                <UseCreditLimitCheckRender />
              </div>
              <div className={style.line}>
                <span>
                  Использование проверки
                  {' '}
                  <u>допустимой</u>
                  {' '}
                  дебиторской задолженности (ДЗ) перед оформлением МХ-3:
                </span>
                <UseDZCheckRender />
              </div>
              <div className={style.line}>
                <span>
                  Использование проверки
                  {' '}
                  <u>просроченной</u>
                  {' '}
                  дебиторской задолженности (ПДЗ) перед оформлением МХ-3:
                </span>
                <UsePDZCheckRender />
              </div>
            </fieldset>
          </>

        )}
        <div className={style.line}>
          <span>Запрет отгрузки:</span>
          <UseProhibitionShippingRender />
        </div>
        <div className={style.line}>
          <span>Печатать СК из QMET:</span>
          <PrintQcFromQmetRender />
        </div>
        <div className={style.line}>
          <span>Печатать СК из хранилища:</span>
          <PrintQcFromStorageRender />
        </div>
        <div className={style.line}>
          <span>Выбор договора при оформлении выкупа</span>
          <UseSetContractBuyoutRender />
        </div>
        <div className={style.line}>
          <span>Конфигурация склада</span>
          <UseStorageLevelsRender />
        </div>
        <div className={style.line}>
          <span>Показывать атрибуты ПФ</span>
          <UseShowSemiAttrbRender />
        </div>
        <div className={style.line}>
          <span>Проверка на разные способы отгрузки</span>
          <CheckDifferentShipmentModeRender />
        </div>
        <div className={style.line}>
          <form className="form"
                method="POST"
                encType="multipart/form-data"
                ref={formFile}
                onSubmit={formOnSubmit}
          >
            <div>
              <FileUploader selectButtonText="Выберите файл для загрузки"
                            labelText=""
                            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            allowedFileExtensions={['.xls', '.xlsx']}
                            uploadMode="useForm"
                            ref={fileUp}
              />
            </div>
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    useSubmitBehavior
                    elementAttr={{ class: style.buttonSaveFile }}
            />
          </form>
        </div>
        <div className={style.line}>
          <form className="form"
                method="POST"
                encType="multipart/form-data"
                ref={formManualFile}
                onSubmit={formOnManualSubmit}
          >
            <div>
              <FileUploader selectButtonText="Выберите файл инструкции для загрузки"
                            labelText=""
                            accept="application/pdf"
                            allowedFileExtensions={['.pdf']}
                            uploadMode="useForm"
                            ref={fileManualUp}
              />
            </div>
            <Button type="default"
                    stylingMode="text"
                    icon="save"
                    useSubmitBehavior
                    elementAttr={{ class: style.buttonSaveManualFile }}
            />
          </form>
        </div>
        <div className={`${style.line} ${style.message}`}>
          <div>
            <Button type="default"
                    text="Новости"
                    elementAttr={{ class: style.buttonSaveFile }}
                    onClick={openModalMessage}
            />
          </div>
        </div>
        <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                   showPane
                   shading={false}
                   showIndicator
                   visible={file.loading}
        />
      </div>
      <PopupMVP visible={visibleModalSettingsTN}
                title={'Предупреждение'}
                onHiding={closeModalTNSettings}>
        <div className="formData">
          <p>Необходимо заполнить настройки печатной формы ТН</p>
          <div className="formButton">
            <Button type="default"
                    text="Заполнить"
                    onClick={closeModalTNSettings}
            />
          </div>
        </div>
      </PopupMVP>
    </>
  );
};

export default SettingsStock;
